import { inject } from '@angular/core';
import { NetworkService } from 'src/app/service/network.service';
import { TranslationService } from 'src/app/service/translation.service';

export abstract class AbstractController {
  protected readonly network: NetworkService;
  protected readonly translationService = inject(TranslationService);

  constructor(networkService: NetworkService) {
   
    this.network = networkService;
  }

  protected getTranslation(key: string): string {
    let translation = '';
    this.translationService.get(key).subscribe((value) => {
      translation = value;
    });
    return translation;
  }
}
